import { assert as sharedAssert, NullDereferenced } from '@rhim/utils';

import { LogRocket } from './tracking';

export * from '@rhim/utils';

/**
 * Decorates the shared assertion helper with APO Portal's LogRocket reporting.
 */
export function assert(condition: boolean, message = NullDereferenced.message): asserts condition {
  sharedAssert(condition, message);
}

assert.silent = (condition: boolean, message = NullDereferenced.message): asserts condition => {
  if (!condition) {
    LogRocket.captureMessage(message);
  }

  sharedAssert.silent(condition, message);
};
